import { render } from "./FlagES.vue?vue&type=template&id=a8a75188"
import script from "./FlagES.vue?vue&type=script&lang=js"
export * from "./FlagES.vue?vue&type=script&lang=js"

import exportComponent from "/vhost/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__